import _Hidden from "@material-ui/core/esm/Hidden";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import { AuthProvider } from "../Auth";
import { Chat, ChatProvider } from "../Chat";
import { ErrorsProvider } from "../Errors";
import { ImagesCarouselProvider } from "../ImagesCarousel";
import { NotificationsProvider } from "../Notifications/NotificationsProvider";
import { SocketProvider } from "../Socket/SocketProvider";
import { Users } from "../Users/Users";
import { UsersProvider } from "../Users/UsersProvider";
import { MessengerProvider } from "./MessengerProvider";
import { useStyles } from "./MessengerStyles";

var _ref2 = /*#__PURE__*/_jsx(Users, {});

var _ref3 = /*#__PURE__*/_jsx(Chat, {});

var _ref4 = /*#__PURE__*/_jsx(_Hidden, {
  mdUp: true
}, void 0, _jsx(Chat, {}));

export const Messenger = _ref => {
  let user = _ref.user,
      socketUrl = _ref.socketUrl,
      eventId = _ref.eventId;
  const classes = useStyles();
  return _jsx(SocketProvider, {
    url: socketUrl
  }, void 0, _jsx(ErrorsProvider, {}, void 0, _jsx(AuthProvider, {
    user: user
  }, void 0, _jsx(ImagesCarouselProvider, {}, void 0, _jsx(NotificationsProvider, {}, void 0, _jsx(MessengerProvider, {}, void 0, _jsx(UsersProvider, {
    eventId: eventId
  }, void 0, _jsx("div", {
    className: classes.container
  }, void 0, _jsx("div", {
    className: classes.userList
  }, void 0, _ref2), _jsx(ChatProvider, {}, void 0, _jsx(_Hidden, {
    smDown: true
  }, void 0, _jsx("div", {
    className: classes.chat
  }, void 0, _ref3)), _ref4)))))))));
};